/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect, useRef, useState } from 'react';
import {
  CpdsCopyrightWrapper,
  CopyrightButton,
  CpdsCopyrightGradient,
  CopyrightTextWrapper,
} from './styles/cpds-copyright-style';
import { CpdsCopyrightProps } from './typings';
import { themeStyleClass } from '../utils/cpds-utils';
import { Cpds } from '@Cpds.Ui';
import { checkValue } from 'src/components/common/helper';

const CpdsCopyright: React.FC<CpdsCopyrightProps> = (props) => {
  const {
    exClasses,
    styleOverrides,
    themeTypography,
    imageCaption,
    imageCopyright,
    copyrightPosition,
    iconSize = 'LG',
  } = props;
  const className = themeStyleClass('cpds-copyright', themeTypography, exClasses);

  const [isShow, toggleIsShow] = useState(false);
  const [parentBorderRadius, setParentBorderRadius] = useState('0px');

  const onMouceOver = (e) => {
    e.stopPropagation();
    e.preventDefault();
    toggleIsShow(true);
  };

  const onMouceLeave = (e) => {
    e.stopPropagation();
    e.preventDefault();
    toggleIsShow(false);
  };

  const wrapperRef = useRef(null);

  useEffect(() => {
    if (wrapperRef.current) {
      // Traverse the DOM to find the parent element
      const parent = wrapperRef.current.parentElement;

      if (parent) {
        // Get computed styles of the parent
        const computedStyles = window.getComputedStyle(parent);

        // Get the border-radius value
        const borderRadius = computedStyles.borderRadius;
        setParentBorderRadius(borderRadius);
      }
    }
  }, []);

  if (!checkValue(imageCopyright) && !checkValue(imageCaption)) {
    return null;
  }

  return (
    <>
      <CpdsCopyrightGradient isShow={isShow} borderRadius={parentBorderRadius} />
      <CpdsCopyrightWrapper
        position={copyrightPosition}
        className={className}
        ref={wrapperRef}
        styleOverrides={styleOverrides}
      >
        <CopyrightTextWrapper isShow={isShow}>
          <span>{imageCopyright}</span>
          <span>{imageCaption}</span>
        </CopyrightTextWrapper>
        <CopyrightButton
          iconSize={iconSize}
          onClick={(e) => onMouceOver(e)}
          onMouseOver={(e) => onMouceOver(e)}
          onMouseLeave={(e) => onMouceLeave(e)}
        >
          <Cpds.Icon id="copyright-icon" name="camera" size="medium" color="#FFFFFF" />
        </CopyrightButton>
      </CpdsCopyrightWrapper>
    </>
  );
};

export default CpdsCopyright;
